<template>
  <ol class="tour-booking-steps font-text-small">
    <li v-for="n in 3" :key="n" class="tour-booking-steps__item">
      <div class="tour-booking-steps__item-container">
        <span
          class="tour-booking-steps__item-text"
          v-html="$t(`serpDetail.bookingSteps[${n}].text`)"
        ></span>
        <tooltip
          v-if="$te(`serpDetail.bookingSteps[${n}].tooltip`)"
          class="tour-booking-steps__tooltip u-flex-shrink-0 u-text-secondary"
          wrap-after-text
        >
          <template #content>
            <div
              class="tour-booking-steps__tooltip-content"
              v-html="$t(`serpDetail.bookingSteps[${n}].tooltip`)"
            ></div>
          </template>
        </tooltip>
      </div>
    </li>
  </ol>
</template>

<script>
import Tooltip from "@/components/ui-kit/tooltip/index.vue";

export default {
  components: {
    Tooltip,
  },
};
</script>

<style lang="scss" scoped>
.tour-booking-steps {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 0;
  margin: 0;
  list-style-type: none;
  counter-reset: steps;

  @include mixin.size-sm {
    max-width: 394px;
  }

  @include mixin.size-md-min {
    font-size: 14px;
    line-height: func.divide(18, 14);
  }

  &__item {
    position: relative;
    padding: 0;
    margin: 0;

    @include mixin.size-md-min {
      display: flex;
      align-items: center;
    }

    &:not(:last-child) {
      padding-right: 20px;

      &::after {
        content: "";
        display: block;
        position: absolute;
        top: 12px;
        right: 0;
        left: 24px;
        height: 1px;
        background: var.$secondary;

        @include mixin.size-md-min {
          content: none;
        }
      }
    }

    &::before {
      content: counter(steps);
      counter-increment: steps;
      box-sizing: border-box;
      font-weight: bold;
      font-size: 11px;
      line-height: 1;
      color: var.$text-dark;
      background: var.$gray-light;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 24px;
      height: 24px;
      margin-bottom: 10px;
      flex-shrink: 0;

      @include mixin.size-md-min {
        margin-right: 8px;
        margin-bottom: 0;
      }
    }

    &-text {
      padding-right: 22px;
    }
  }

  &__tooltip {
    &-content {
      >>> img {
        max-width: 125px;
      }
    }
  }
}
</style>
